import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../api/axiosInstance";
import { ExtendedRight, SearchOfIndicators, } from "../../../../interfaces/Rights";
import { ODSPriorityGroups } from "../../../../interfaces/Indicator";
const { REACT_APP_API_PATH } = process.env;

interface GeOptionsResponse {
    rights: ExtendedRight[],
    ods: ODSPriorityGroups[],
    grupos_prioritarios: ODSPriorityGroups[]
}

interface GetExtendedRightResponse {
    right: ExtendedRight,
}


interface GetExtendedRightQuery {
    right: string,
    period: string
}

interface GetSearchOfIndicators {
    search: SearchOfIndicators[] | null
    error?: string | undefined
}

interface GetSearchOfIndicatorsQuery {
    search: string;
    startPeriod?: number;
}

interface ErrorResponse {
    message: string;
    // otros campos relevantes del error
}

export const getExtendedRight = createAsyncThunk<GetExtendedRightResponse, GetExtendedRightQuery, { rejectValue: ErrorResponse }>(
    "display/getExtendedRight",
    async ({ right, period }: GetExtendedRightQuery) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/derechos?titulo=${right}&period=${period}`)
            const data = response.data

            return {
                right: data.data,
            }
        } catch (error: any) {
            return {
                right: [],
            };
        }
    }
);

export const getOptions = createAsyncThunk<GeOptionsResponse, { period: string }, { rejectValue: ErrorResponse }>(
    "display/getOptions",
    async ({ period }) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/indicadores/options?period=${period}`)
            const data = response.data
            return {
                rights: data.rights,
                ods: data.ods,
                grupos_prioritarios: data.grupos_prioritarios
            }
        } catch (error: any) {
            return {
                rights: [],
                ods: [],
                grupos_prioritarios: []
            };
        }
    }
);

export const getSearchOfIndicators = createAsyncThunk<GetSearchOfIndicators, GetSearchOfIndicatorsQuery, { rejectValue: ErrorResponse }>(
    "display/search",
    async ({ search, startPeriod }: GetSearchOfIndicatorsQuery) => {
        try {
            const params = new URLSearchParams();
            if (search) params.append('search', search);
            if (startPeriod) params.append('startPeriod', startPeriod.toString())

            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/indicadores?${params.toString()}&searchMode=predictive`);
            const data = response.data
            return {
                search: data.data.data
            }
        } catch (error: any) {
            return {
                search: null,
                error: "No se encontraron indicadores."
            };
        }
    }
);